import { useState } from "react";
import api from "@/lib/api";
import { Lock, Loader2, Utensils } from "lucide-react";

export default function AuthGate({ onAuth }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { password });
      localStorage.setItem("vlf_token", data.token);
      onAuth();
    } catch (err) {
      setError(err.response?.data?.detail || "Connexion impossible");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-25 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1512838243191-e81e8f66f1fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B0F12]/80 via-[#0B0F12]/90 to-[#0B0F12]" />

      <form
        onSubmit={submit}
        data-testid="login-form"
        className="relative z-10 w-full max-w-sm vlf-fade-up bg-[#131920]/95 backdrop-blur-xl border border-[#253242] rounded-2xl p-8 shadow-[0_10px_40px_rgba(0,0,0,0.5)]"
      >
        <div className="flex items-center gap-3 mb-1">
          <div className="w-12 h-12 rounded-xl bg-[#FF5A1F] flex items-center justify-center shadow-[0_0_24px_-4px_rgba(255,90,31,0.6)]">
            <Utensils className="w-6 h-6 text-white" />
          </div>
          <div>
            <h1 className="text-xl font-extrabold tracking-tight leading-none">Ventes Lekker Food</h1>
            <p className="text-xs text-[#94A3B8] mt-1">Krousty Tacos • Ninove</p>
          </div>
        </div>

        <p className="text-sm text-[#94A3B8] mt-6 mb-4 flex items-center gap-2">
          <Lock className="w-4 h-4 text-[#F59E0B]" /> Espace protégé — saisissez votre mot de passe
        </p>

        <input
          data-testid="login-password-input"
          type="password"
          inputMode="text"
          autoFocus
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Mot de passe"
          className="w-full h-14 px-4 rounded-xl bg-[#0B0F12] border border-[#253242] text-lg font-mono text-white outline-none focus:border-[#FF5A1F] transition-colors"
        />

        {error && (
          <p data-testid="login-error" className="text-[#EF4444] text-sm mt-3">
            {error}
          </p>
        )}

        <button
          data-testid="login-submit-button"
          type="submit"
          disabled={loading || !password}
          className="w-full h-14 mt-5 rounded-xl bg-[#FF5A1F] hover:bg-[#E04810] disabled:opacity-50 text-white font-bold text-lg flex items-center justify-center gap-2 active:scale-[0.98] transition-all"
        >
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Déverrouiller"}
        </button>
      </form>
    </div>
  );
}
